import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { FreeTrailDialogService } from './free-trail-dialog.service';
import { FreeTrailDialogServiceImpl } from './impls/free-trail-dialog-service';

/**
 * 免费试用对话框模块
 * @description 注册免费试用对话框服务到 DI 容器
 */
export const freeTrailModule = new ContainerModule((bind) => {
    bind(FreeTrailDialogService).to(FreeTrailDialogServiceImpl);
});
